import { FunctionalComponent, h } from "preact";
import { Route, Router } from "preact-router";
import { TranslateProvider } from "@denysvuika/preact-translate";
import style from "./components/common/style.scss";

import NotFoundPage from "./routes/notfound";

import HomeContainer from "./routes/home";

import EnLang from "./translations/en.json";
import RuLang from "./translations/ru.json";
import TextPageContainer from "./routes/text-page";
import AgreementString from "./translations/agreement.md";
import PrivacyPolicyString from "./translations/privacy-policy.md";
import LegalInfoString from "./translations/legal-info.md";
import PaymentLogos from "./assets/images/payment_logos.png";
import { CommonFeaturePage } from "./routes/features-pages/feature-page";
import { researchData } from "./routes/features-pages/research";
import { maintenanceData } from "./routes/features-pages/maintenance";
import { analysisData } from "./routes/features-pages/analysis";
import { developmentData } from "./routes/features-pages/development";
import { designData } from "./routes/features-pages/design";

const App: FunctionalComponent = () => {
  // TODO: Language picker
  const userLang = 'en' // navigator.language
  return (
    <TranslateProvider
        lang={userLang.includes('ru') ? 'ru' : 'en'}
      translations={{
        en: EnLang,
        ru: RuLang,
      }}
    >
      <div id="preact_root" className={style.root}>
        <Router>
          <Route path="/" component={HomeContainer} />
          <Route
            path="/analysis"
            component={() => <CommonFeaturePage data={analysisData} />}
          />
          <Route
            path="/design"
            component={() => <CommonFeaturePage data={designData} />}
          />
          <Route
            path="/development"
            component={() => <CommonFeaturePage data={developmentData} />}
          />
          <Route
            path="/research"
            component={() => <CommonFeaturePage data={researchData} />}
          />
          <Route
            path="/maintenance"
            component={() => <CommonFeaturePage data={maintenanceData} />}
          />
          <Route
            path="/agreement"
            component={() => <TextPageContainer string={AgreementString} />}
          />
          <Route
            path="/privacy"
            component={() => <TextPageContainer string={PrivacyPolicyString} />}
          />
          <Route
            path="/legal-info"
            component={() => <TextPageContainer string={LegalInfoString} />}
          />
          <Route
            path="/payment-rules"
            component={() => (
              <TextPageContainer>
                <h1>
                  Правила оплаты
                  <br />
                  Политика безопасности
                </h1>
                <p>
                  При оплате заказа банковской картой, обработка платежа
                  (включая ввод номера карты) происходит на защищенной странице
                  процессинговой системы, которая прошла международную
                  сертификацию. Это значит, что Ваши конфиденциальные данные
                  (реквизиты карты, регистрационные данные и др.) не поступают в
                  интернет-магазин, их обработка полностью защищена и никто, в
                  том числе наш интернет-магазин, не может получить персональные
                  и банковские данные клиента. При работе с карточными данными
                  применяется стандарт защиты информации, разработанный
                  международными платёжными системами Visa и Masterсard-Payment
                  Card Industry Data Security Standard (PCI DSS), что
                  обеспечивает безопасную обработку реквизитов Банковской карты
                  Держателя. Применяемая технология передачи данных гарантирует
                  безопасность по сделкам с Банковскими картами путем
                  использования протоколов Secure Sockets Layer (SSL),
                  Verifiedby Visa, Secure Code,и закрытых банковских сетей,
                  имеющих высшую степень защиты.
                </p>

                <img src={PaymentLogos} />

                <p>
                  <b>
                    Уважаемые Клиенты, информируем Вас о том, что при запросе
                    возврата денежных средств при отказе от покупки, возврат
                    производится исключительно на ту же банковскую карту, с
                    которой была произведена оплата
                  </b>
                </p>
              </TextPageContainer>
            )}
          />
          <NotFoundPage default />
        </Router>
      </div>
    </TranslateProvider>
  );
};

export default App;
